import { render, staticRenderFns } from "./FormBeneficiario.vue?vue&type=template&id=dd330f78&scoped=true"
import script from "./FormBeneficiario.vue?vue&type=script&lang=ts"
export * from "./FormBeneficiario.vue?vue&type=script&lang=ts"
import style0 from "./FormBeneficiario.vue?vue&type=style&index=0&id=dd330f78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd330f78",
  null
  
)

export default component.exports